import client from '../../../apiClient';

const API_PATH = process.env.REACT_APP_API_PATH || '';

export const fetchAllTickets = async () => {
  try {
    const { data } = await client
      .get(`${API_PATH}/entities`, { params: { type: 'ticket' } })
      .catch(console.error);

    return data;
  } catch (rejection) {
    console.error(rejection);
  }
};

export const fetchTicketsById = async id => {
  try {
    const { data } = await client.get(`${API_PATH}/insights`, {
      params: { type: 'ticket', id },
    });

    return data;
  } catch (rejection) {
    console.error(rejection);
  }
};

export const fetchAllSales = async () => {
  try {
    const { data } = await client.get(`${API_PATH}/entities`, {
      params: { type: 'sale' },
    });

    return data;
  } catch (rejection) {
    console.error(rejection);
  }
};

export const fetchSalesById = async id => {
  try {
    const { data } = await client.get(`${API_PATH}/insights`, {
      params: { type: 'sale', id },
    });

    return data;
  } catch (rejection) {
    console.error(rejection);
  }
};
